import { writable } from "svelte/store";

export type Config = { campaign: string; };

export const initStore = () => writable<Config>();
export const configStore = initStore();
export const set = (config: Config) => configStore.set(config);
